import script from "./MyReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./MyReviews.vue?vue&type=script&setup=true&lang=js"

import "./MyReviews.vue?vue&type=style&index=0&id=7616ffc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7616ffc8"]])

export default __exports__